import { render, staticRenderFns } from "./HomeRoute.vue?vue&type=template&id=466d7660&"
import script from "./HomeRoute.vue?vue&type=script&lang=ts&"
export * from "./HomeRoute.vue?vue&type=script&lang=ts&"
import style0 from "./HomeRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports